export const environment = {
  production: true,
  apiEndpoint: 'https://dev-api.focusro.com',
  timeout: 5000,
  imageEndpoint: 'https://dev-screen.focusro.com/',
marketingApi: 'https://dev-marketing-api.focusro.com',
  pabblyCheckoutUrl: 'https://payments.pabbly.com/subscribe/63b6cc58215f2a0aae6e8bae/free-trial',
  pabblyCheckoutUrlIN: 'https://payments.pabbly.com/subscribe/642fb43889a8cb1840f45fb7/free-in',
  stripePublishKey:'pk_test_51O0HCZSCeiDXzp9qhQmH43AV05cP7x6j97Upu4RT3jHVrTV3VTyl5vuqahfXLu2QgCuUMdDza41tBu6PaZTONMK500gJGA3nyV',
  appTrackingDeploymentDate: '2023-01-20',
  orgCode:["RSB"],
  mobileAppOrgCode:['foc'],
  restApiServiceEndpoint: 'https://dev-connect.focusro.com',
  ebdCode:'https://dev-api.focusro.com/api/v1/public/embed/focusro-job-posting-widget.min.js',
  turnUrl: 'myturn.focusro.com:3478',
  turnUser: 'mywebrtcuser',
  turnPass: 'mywebrtcpassword'
};
